import { StateCreator } from 'zustand';
import { WorkflowCreationMetaDataStoreType } from './workflowCreationMetaDataStore.interface';
import { Store } from 'src/stores/store.interface';
import { WorkflowIntention } from '@amzn/snow-nxt-workflow-service-typescript-client';

export const defaultWorkflowCreationMetaDataStore = {
	workflowCreationMetaData: {
		workflowDefinitionName: '',
		description: '',
		entityType: '',
		lastUpdatedBy: '',
		createdBy: '',
		domains: [],
		status: '',
		lastUpdateTime: 0,
		createdAt: 0,
		workflowId: '',
		version: 0,
		supportedTasks: [''],
		approvalRequiredToStartExecution: false,
		batchExecutionRequired: false,
		workflowIntention: WorkflowIntention.CREATE,
		isReRunAllowed: false,
		workflowApprovalMetadata: {
			isWorkflowAutoTriggeredAfterApproval: true,
			workflowExecutionApprovers: [{
				type: 'string',
				alias: 'string',
				numberOfApprovers: 1,
				level: 1,
			}],
		},
	},
	isEditing: false,
};

const workflowCreationMetaDataStore: StateCreator<
	Store,
	[],
	[],
	WorkflowCreationMetaDataStoreType
> = (set, get) => ({
	...defaultWorkflowCreationMetaDataStore,
	setWorkflowId: (workflowId) =>
		set({
			workflowCreationMetaData: {
				...get().workflowCreationMetaData,
				workflowId,
			},
		}),
	setIsEditing: (isEditing) => set({ isEditing }),
});

export default workflowCreationMetaDataStore;
